module.exports = __webpack_public_path__ + "static/media/faucet.4db0a209.svg";